module.exports = __webpack_public_path__ + "img/quick-event.fc804b61.svg";